<template>
  <Modal
    :id="'cmp-royalty-royalty_accounts-sidewindow-abalance_advance_form'"
    @cancelled="onCancel"
  >
    <template slot="header">Advance Search</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'start_date'"
            class="m1"
            v-bind="textFieldConfig"
            type="date"
            :value="searchModel.start_date"
            required
            showValidationIcons
            :placeholder="$t('start_date')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'end_date'"
            class="m1"
            v-bind="textFieldConfig"
            type="date"
            :value="searchModel.end_date"
            required
            showValidationIcons
            :placeholder="$t('end_date')"
            @valuechanged="onTextFieldValueChange"
          />
          <Dropdown
            :id="'period'"
            class="m2"
            :options="periodTV"
            :selected="periodTV.find((b) => b.value == searchModel.period)"
            :placeholder="$t('period')"
            deselect
            box
            @selectedChange="(b) => onDropdownChange('period', b)"
          ></Dropdown>
          <Dropdown
            :id="'contract'"
            class="m2"
            :options="contractTV"
            :selected="contractTV.find((b) => b.value == searchModel.contract)"
            :placeholder="$t('Account/Contract')"
            deselect
            box
            @selectedChange="(b) => onDropdownChange('contract', b)"
          ></Dropdown>
          <TextField
            :id="'description'"
            class="m1"
            v-bind="textFieldConfig"
            type="text"
            :value="searchModel.description"
            required
            showValidationIcons
            :placeholder="$t('description')"
            @valuechanged="onTextFieldValueChange"
          />
          <Dropdown
            :id="'balance_type'"
            class="m2"
            :options="balanceTypeTV"
            :selected="
              balanceTypeTV.find((b) => b.value == searchModel.balance_type)
            "
            :placeholder="$t('balance_type')"
            deselect
            box
            @selectedChange="(b) => onDropdownChange('balance_type', b)"
          ></Dropdown>
          <!-- <TextField
            :id="'amount_start'"
            class="m1"
            v-bind="textFieldConfig"
            type="text"
            :value="searchModel.amount_start"
            required
            showValidationIcons
            :placeholder="$t('amount_start')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'amount_end'"
            class="m1"
            v-bind="textFieldConfig"
            type="text"
            :value="searchModel.amount_end"
            required
            showValidationIcons
            :placeholder="$t('amount_end')"
            @valuechanged="onTextFieldValueChange"
          /> -->
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">Search</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import { AccountsService } from "../../services/accounts.service";
import { RoyaltyStoreNamespace as storeNS } from "../../store";
import { mapActionObject } from "../../../../store/global";
import { accountsRoyaltyActions } from "../../store/accounts/actions";
import * as ActionTypes from "../../store/types";
export default {
  components: {
    Modal,
    InputField,
  },
  props: ["selectedAccountDetails"],
  data() {
    return {
      digitalBaseTV: [],

      searchModel: {
        amount_end: null,
        start_date: null,
        end_date: null,
        period: null,
        contract: null,
        account: null,
        description: null,
        balance_type: null,
        amount_start: null,
      },
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
      },
      validationResult: {},
    };
  },

  computed: {
    royalty_account_id: function () {
      return this.$route.params.royalty_account_id;
    },
    balanceTypeTV: function () {
      return [
        { text: "Advance", value: "1" },
        { text: "Recoupable", value: "2" },
        { text: "Credit Return Reserve", value: "3" },
        { text: "Closing Balance", value: "4" },
        { text: "Royalty Payment", value: "5" },
      ];
    },
    periodTV: function () {
      return [{ text: "Open Balances", value: "open_balances" }];
    },
    contractTV: function () {
      return [{ text: "Account", value: "Account" }];
    },
  },
  methods: {
    ...mapActionObject(storeNS, accountsRoyaltyActions),

    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onTextFieldValueChange: function (name, value) {
      this.searchModel[name] = value;
      this.$emit("search", this.searchModel);
    },
    onDropdownChange(name, value) {
      this.searchModel[name] = value.value;
      if (name === "contract") {
        this.searchModel["account"] = 1;
      }
      this.$emit("search", this.searchModel);
    },
    onOkClick: async function () {
      const result = await AccountsService.balanceAdvanceSearchWithoutString({
        royalty_account_id: this.royalty_account_id,
        ...this.searchModel,
      });
      console.log("result.data.balances", result.data.balances);
      this.$emit("added", result.data.balances);
    },
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
    },
  },
};
</script>

<style lang="scss">
.cmp-royalty-royalty_accounts-sidewindow-abalance_advance_form {
  // border: 1px solid var(--sprt-5);
}
</style>
